import type { VenueClientModule } from "../types";
import { CasinoHud } from "./CasinoHud";
import { buildCasino3d } from "./scene/casinoScene";

/** Townsy Casino on the client (ADR-0016): the casino floor's 3D and its overlay; both only display the server's game. */
export const casinoClient: VenueClientModule = {
  kind: "casino",
  build3d: buildCasino3d,
  Hud: CasinoHud,
};
